import { render, staticRenderFns } from "./avcollect.vue?vue&type=template&id=dc15ecb6&scoped=true&"
import script from "./avcollect.vue?vue&type=script&lang=js&"
export * from "./avcollect.vue?vue&type=script&lang=js&"
import style0 from "./avcollect.vue?vue&type=style&index=0&id=dc15ecb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc15ecb6",
  null
  
)

export default component.exports